import { isNullOrUndefined } from 'util';
import { EventPieceJointe } from '../piece-jointe';

import { Address, Contact, AccountType } from '../../shared';

export enum RequeteStatut {
    ENVOYE = 'Envoyé',
    REFUSE = 'Refusé',
    RATTACHE = 'Rattaché',
    EN_ATTENTE_DE_RATTACHEMENT= 'En attente de rattachement',
    DOSSIER_NON_ACCESSIBLE = 'Dossier non accessible',
    AUTRES = '-'
}

export enum RequeteCategory {
    REQUERANT_SEUL = 'REQUERANT_SEUL',
    COLLECTIVE = 'COLLECTIVE',
    AVEC_MANDATAIRE = 'AVEC_MANDATAIRE'
}

export interface EventRequete {
    id?: number;
    subEventId?: string;
    direction?: string;
    mesureId?: string;
    mesureLibelle?: string;
    nomActeur?: string;
    acteurIdTr?: number;
    isTrc?: boolean;
    isDraft?: boolean;
    type?: string;
    dateEvt?: Date;
    dateReception?: Date;
    pieces?: EventPieceJointe[];
}

export class PartieDepot {
    type: AccountType;
    userId?: number;
    email?: string;
    qualite: QualityType;
    civilite?: string;
    firstName?: string;
    lastName?: string;
    nomEntreprise?: string;
    sigleEntreprise?: string;
    contact: Contact = {};
    address: Address = {} as Address;

    clone(): PartieDepot {
        const clone: PartieDepot = new PartieDepot();
        clone.type = this.type;
        clone.userId = this.userId;
        clone.email = this.email;
        clone.qualite = this.qualite;
        clone.civilite = this.civilite;
        clone.firstName = this.firstName;
        clone.lastName = this.lastName;
        clone.nomEntreprise = this.nomEntreprise;
        clone.sigleEntreprise = this.sigleEntreprise;
        clone.address = Object.assign({}, this.address);
        clone.contact = Object.assign({}, this.contact);
        return clone;
    }

    get isAnonymous(): boolean {
        return isNullOrUndefined(this.userId);
    }

    get isMorale(): boolean {
        return AccountType.MORALE === this.type;
    }

}

export interface Partie {
    qualite?: QualityType;
    nom?: string;
    nomMandataire?: string;
    userId?: number;
}

export class SyntheseDossier {
    TRC_ID_DOSS: number;
    REQUERANT: string;
    DEFENDEUR: string;
    ID_AFFECTATION: number;
    AFFECTATION: string;
    ANALYSE: string;
    DATE_ETAT: string;
    ID_ETAT: number;
    LIB_ETA: string;
    ETAT_TEXTE3: string;
    EST_TELERECOURS: string;
    EST_ISSU_REQUETE_TRC: string;
    DISPOSITIF: string;
}

export class SensConclusion {
    DATE_HEURE_AUDIENCE: string;
    DATE_HEURE_MISE_EN_LIGNE: string;
    SENS_SYNTHETIQUE_CONC: string;
    SENS_CONCLUSION: string;
}

export class RequeteDetail {
    id: number;
    numeroRequete: string;
    numeroRequeteProvisoire: string;
    titre: string;
    renamed: boolean;
    parties: Partie[];
    events: EventRequete[];
    typeRequeteId: number;
    siteJuridictionId: number;
    siteJuridictionLabel: string;
    statut: string;
    dateModification: Date;
    isSync: boolean;
    syntheseDossier: SyntheseDossier;
    sensConclusions: SensConclusion[];
    dossierCorreles: Array<RequeteSummary>;
    motif: string;
}

export class RequeteSummary {
    id: number;
    numeroRequete: string;
    numeroRequeteProvisoire: string;
    titre: string;
    description: string;
    juridiction: string;
    statut: string;
    dateModification: Date;
    isSync: boolean;
    dossierCorreles: Array<RequeteSummary>;
    isLinked: boolean;
}

export type Requete = RequeteSummary | RequeteDetail;

export enum QualityType {
    Requerant = 'R',
    IntervenantEnRequete = 'IR',
    Defendeur = 'D',
    IntervenantEnDefense = 'ID',
    Observateur = 'O',
    ExpertMediateur = 'E',
    Sapiteur = 'S',
    Interprete = 'I',
    Temoin = 'T',
    Avocat = 'A',
    Avoue = 'AE',
    Mandataire = 'M',
    Pseudoacteur = 'P'
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/requete/requete.model.ts